import { render } from "./Outer.vue?vue&type=template&id=5cbabd92&scoped=true&lang=pug"
import script from "./Outer.vue?vue&type=script&lang=js"
export * from "./Outer.vue?vue&type=script&lang=js"

import "./Outer.vue?vue&type=style&index=0&id=5cbabd92&scoped=true&lang=css"

import exportComponent from "C:\\Users\\USER\\freemath\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5cbabd92"]])

export default __exports__